import { ApiSchema } from '../lib/query/apiClient';
import { Language } from '../models';
import { ActionMap } from '../types';
import { Locale, languages } from '../utils/locales';

type FeatureDto = ApiSchema<'FeatureDto'>;
export type ConfigurationState = {
  features: FeatureDto[];
  language: Language;
  locale?: Locale;
};

export const initialConfigurationState: ConfigurationState = {
  features: [],
  language: Language.nb,
};

export enum ConfigurationActionTypes {
  SetLanguage = 'SET_LANGUAGE',
  SetFeatures = 'SET_FEATURES',
}

// Configuration

type ConfigurationPayload = {
  [ConfigurationActionTypes.SetLanguage]: Language;
  [ConfigurationActionTypes.SetFeatures]: ApiSchema<'FeatureDto'>[];
};

export type ConfigurationActions = ActionMap<ConfigurationPayload>[keyof ActionMap<ConfigurationPayload>];

export const configurationReducer = (state: ConfigurationState, action: ConfigurationActions) => {
  switch (action.type) {
    case ConfigurationActionTypes.SetLanguage:
      return {
        ...state,
        language: action.payload,
        locale: languages.get(action.payload),
      };
    case ConfigurationActionTypes.SetFeatures:
      return {
        ...state,
        features: action.payload,
      };
    default:
      return state;
  }
};
